// lib/echo.ts

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
    interface Window {
        Pusher: typeof Pusher;
        echo?: Echo<any>;
    }
}

let echo: Echo<any> | null = null;

if (typeof window !== 'undefined') {
    window.Pusher = Pusher;
    if (window.echo) {
        echo = window.echo;
    } else {
        echo = new Echo({
            broadcaster: 'reverb',
            key: process.env.NEXT_PUBLIC_REVERB_APP_KEY,
            wsHost: process.env.NEXT_PUBLIC_REVERB_HOST,
            wsPort: Number(process.env.NEXT_PUBLIC_REVERB_PORT ?? 8080),
            wssPort: Number(process.env.NEXT_PUBLIC_REVERB_PORT ?? 443),
            forceTLS: (process.env.NEXT_PUBLIC_REVERB_SCHEME ?? 'https') === 'https',
            enabledTransports: ['ws', 'wss'],
        });

        window.echo = echo;
    }
}

export default echo;